import { errorMessage } from "@api/errors";
import { Button } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { LoadingBar } from "./LoadingBar";

export function QueryFeedback({ busy, error, retry, label }: { busy: boolean; error?: unknown; retry?: () => unknown; label?: string }) {
  const { t } = useTranslation();
  return (
    <div aria-busy={busy}>
      <LoadingBar active={busy} label={label} />
      {Boolean(error) && (
        <div className="note err sm" role="alert">
          {errorMessage(error)}{" "}
          {retry && (
            <Button size="compact-xs" variant="default" onClick={() => void retry()}>
              {t("async.retry")}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
